import { useApp, useAuth } from '@web-kc/core/providers';
import { PlanListProvider, usePlanList } from './providers';
import React from 'react';
import { CreateEditPlanModal } from './components/createEditPlanModal';
import { PlanListHeader } from './components/PlanListHeader';
import { PlanListTable } from './components/PlanListTable';

function PlanListContent() {
  const { isAirAstana } = useAuth();
  const isRti = useApp() === 'rti';
  const {
    data,
    isLoading,
    searchFilters,
    isCreateModalOpen,
    handleChangePageNumber,
    handleCreatePlan,
    handleCreatePurchase,
    handleRowClick,
    handleCloseModal,
  } = usePlanList();

  return (
    <>
      <PlanListHeader
        showActionButtons={isAirAstana || isRti}
        onCreatePlan={handleCreatePlan}
        onCreatePurchase={handleCreatePurchase}
      />

      <PlanListTable
        data={data}
        isLoading={isLoading}
        isRti={isRti}
        currentPage={searchFilters.page ? Number(searchFilters.page) + 1 : 1}
        onPageChange={handleChangePageNumber}
        onRowClick={handleRowClick}
      />

      {isCreateModalOpen && (
        <CreateEditPlanModal handleClose={handleCloseModal} />
      )}
    </>
  );
}

export function PlanListWrapped() {
  return (
    <PlanListProvider>
      <PlanListContent />
    </PlanListProvider>
  );
}
